// components/ResumenPagos.js
import { Paper, Grid, Typography, Divider } from '@mui/material';
import { formatImporte } from '../utils/formatters';

export const ResumenPagos = ({ totalPagos, totalFactura }) => {
  const diferencia = totalFactura - totalPagos;
  
  return (
    <Paper elevation={1} sx={{ p: 2, mt: 1, borderRadius: 2, bgcolor: '#f5f5f5' }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            Total Pagos:
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="#2E7D32">
            ${formatImporte(totalPagos)}
          </Typography>
        </Grid>
        <Grid item>
          <Divider orientation="vertical" flexItem sx={{ height: 40 }} />
        </Grid>
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            Total Factura:
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="#1976D2">
            ${formatImporte(totalFactura)}
          </Typography>
        </Grid>
        <Grid item>
          <Divider orientation="vertical" flexItem sx={{ height: 40 }} />
        </Grid>
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            Diferencia:
          </Typography>
          <Typography variant="h6" fontWeight="bold" color={diferencia > 0 ? "#E67E22" : "#27AE60"}>
            ${formatImporte(Math.abs(diferencia))}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};